import { EventDetailsPlaceholder } from "components/event-details-placeholder"
import { SelectTicketsPlaceholder } from "pages/select-tickets/select-tickets-placeholder"

const HeaderPlaceholder = () => {
  return (
    <header className="shadow">
      <div className="container mx-auto px-4 py-6 flex justify-center">
        <div className="w-48 h-6 bg-gray-300 animate-pulse rounded" />
      </div>
    </header>
  )
}

const ProgressBarPlaceholder = () => {
  return (
    <div className="w-full h-1 bg-theme_text_light">
      <div
        className="h-full bg-gray-300 animate-pulse"
        style={{ width: "33.33%" }}
      />
    </div>
  )
}

const AppPlaceholder = () => {
  return (
    <div>
      <HeaderPlaceholder />
      <ProgressBarPlaceholder />
      <EventDetailsPlaceholder />
      <SelectTicketsPlaceholder />
    </div>
  )
}

export { AppPlaceholder }
